/** Стиль-пак «flat-sharp» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'flat-sharp',
  shape: {
    radiusCard: 4, radiusOption: 6, radiusButton: 4, radiusImage: 4,
    borderWidth: 0, borderTone: 'none', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 44, optionPadY: 12, optionPadX: 16, gap: 8, contentMaxWidth: 480, screenPadX: 16 },
  type: {
    headingFamily: 'sans', h1Size: 24, h1Weight: 700, h1Tracking: 0,
    qSize: 24, qWeight: 700, qTracking: 0, optionSize: 16, optionWeight: 500,
    headingAlign: 'center', overlineTransform: 'none',
  },
  chrome: { progress: 'bar', progressLabel: 'none', counter: false, backButton: 'icon-bare', logo: 'left' },
  cta: { placement: 'inline', fullWidth: true, height: 44, disabledStyle: 'grey' },
  states: { selected: 'filled', hoverTint: true, transitionMs: 150, screenFadeMs: 0 },
  imagery: {
    optionCard: 'label-overlay-top', overlayTone: 'brand', frame: 'rounded',
    promptHint: 'flat vector illustration, two-tone, no gradients',
  },
  // Blinkist: утилитарная плотная колонка от верхнего левого угла. Картинки
  // пака — плоская двухцветная графика: вуаль испортила бы плоский цвет,
  // а тёмный текст темы читается по ней и без затемнения.
  layout: { alignY: 'top', alignX: 'left', backgroundOverlay: 'none' },
  // Blinkist-строгость: инженерный индикатор — одна полоса и процент,
  // без театра стадий, который этому паку чужд.
  loader: {
    style: 'plain-bar', showPercent: true, socialProof: 'review',
    answersSummary: false, engagementModals: true,
  },
  // Blinkist-строгость: инженерный пак не торгует срочностью — ни таймера,
  // ни промо-тикета. Помесячная цена, тарифы отделены плоской шапкой-крышкой,
  // покупка на месте, без sticky-дубля и без повтора внизу.
  paywall: {
    timer: 'none', promoTicket: 'none', priceMode: 'per-month',
    planHighlight: 'cap-header', dimUnselectedPlans: false,
    stickyHeader: false, repeatPurchaseBlock: false,
  },
  // Плоский строгий язык обходится одним акцентом — брендовым; премиум
  // отдельным цветом не помечается, это украшение чужого пака.
  accents: { money: 'brand', premium: 'none' },
};
